import { handleResponse, restartUserSession, authHeader } from '../helpers'

export const blogService = {
    get,
    getNew,
    getWithSubscription,
    cancelSubscription,
    resumeSubscription,
    saveSettings,
    saveBlogSettings,
    getUsers,
    getInvites,
    inviteUser,
    updateUser,
    deleteUser,
    resendInvite,
    deleteInvite,
    removeLogo,
    refreshGhostSettings,
    stripeConnect,
    stripeDisconnect,
    setupGhostConnection,
    saveOnboardingSettings,
    getReportsData,
    getIntegrationData,
    doIntegrationAction,
    requestPlanUpgrade,
    requestDeleteAccount,
    loadMetadata,
    saveNotifications,
    getCssColors,
    loadDemoPosts,
    createDemoPosts,
    deleteDemoPosts,
}

function get (id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/get/${id}`, requestOptions).then(handleResponse)
}

function getNew () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/get-new`, requestOptions).then(handleResponse)
}

function getWithSubscription (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/get-with-subscription/${id}`, requestOptions).then(handleResponse)
}

function cancelSubscription (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/cancel-subscription/${id}`, requestOptions).then(handleResponse)
}

function resumeSubscription (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/resume-subscription/${id}`, requestOptions).then(handleResponse)
}

function saveSettings (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/save-settings`, requestOptions).then(handleResponse)
}

function saveBlogSettings (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/save-blog-settings`, requestOptions).then(handleResponse)
}

function getInvites () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/blog/invites`, requestOptions).then(handleResponse)
}

function getUsers () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/blog/users`, requestOptions).then(handleResponse)
}

function inviteUser (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/invite-user`, requestOptions).then(handleResponse)
}

function resendInvite (id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/resend-invite/${id}`, requestOptions).then(handleResponse)
}

function deleteInvite (id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/delete-invite/${id}`, requestOptions).then(handleResponse)
}

function updateUser (id, params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/user/${id}`, requestOptions).then(handleResponse)
}

function deleteUser (id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    }
    return fetch(`/blog/user/${id}`, requestOptions).then(handleResponse)
}

function removeLogo (id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/delete-logo/${id}`, requestOptions).then(handleResponse)
}

function refreshGhostSettings (id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/refresh-ghost-settings/${id}`, requestOptions).then(handleResponse)
}

function stripeConnect (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/stripe-connect`, requestOptions).then(handleResponse)
}

function stripeDisconnect () {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/stripe-disconnect`, requestOptions).then(handleResponse)
}

function setupGhostConnection (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/setup-ghost-connection`, requestOptions).then(handleResponse)
}

function saveOnboardingSettings (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/save-onboarding-settings`, requestOptions).then(handleResponse)
}

function getReportsData (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/get-reports-data`, requestOptions).then(handleResponse)
}

function getIntegrationData (integrationName, params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/get-integration-data/` + integrationName, requestOptions).then(handleResponse)
}

function doIntegrationAction (integrationName, params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/do-integration-action/` + integrationName, requestOptions).then(handleResponse)
}

function requestPlanUpgrade () {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    }
    return fetch(`/blog/request-plan-upgrade`, requestOptions).then(handleResponse)
}

function loadMetadata () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/metadata`, requestOptions).then(handleResponse)
}

function getPaypalConnectUrl () {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/get-paypal-connect-url`, requestOptions).then(handleResponse)
}

function paypalConnect (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/paypal-connect`, requestOptions).then(handleResponse)
}
function paypalDisconnect () {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/paypal-disconnect`, requestOptions).then(handleResponse)
}

function saveNotifications (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/save-notifications`, requestOptions).then(handleResponse)
}

function requestDeleteAccount () {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    }
    return fetch(`/blog/request-delete-account`, requestOptions).then(handleResponse)
}

function getCssColors () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/css-colors`, requestOptions).then(handleResponse)
}

function loadDemoPosts () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/demo-posts`, requestOptions).then(handleResponse)
}

function createDemoPosts () {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/blog/demo-posts`, requestOptions).then(handleResponse)
}

function deleteDemoPosts () {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    }
    return fetch(`/blog/demo-posts`, requestOptions).then(handleResponse)
}

